import fetchCustomerAddressList from './fetchCustomerAddresses';

export default fetchCustomerAddressList;
